<template>
  <svg viewBox="0 0 36 28" v-on="$listeners">
    <path
      d="M4 20v-12h14v12h-14zM34 9c1.109 0 2 0.891 2 2v6c0 1.109-0.891 2-2 2v2.5c0 1.375-1.125 2.5-2.5 2.5h-29c-1.375 0-2.5-1.125-2.5-2.5v-15c0-1.375 1.125-2.5 2.5-2.5h29c1.375 0 2.5 1.125 2.5 2.5v2.5zM34 17v-6h-2v-4.5c0-0.281-0.219-0.5-0.5-0.5h-29c-0.281 0-0.5 0.219-0.5 0.5v15c0 0.281 0.219 0.5 0.5 0.5h29c0.281 0 0.5-0.219 0.5-0.5v-4.5h2z"
    ></path>
  </svg>
</template>

<script>
export default {
  name: 'battery-2',
}
</script>
